import {
  GROUP_EDIT_CONTEXT_REQUEST,
  GROUP_EDIT_CONTEXT_SUCCESS,
  GROUP_EDIT_CONTEXT_FAILURE,
  GROUP_EDIT_SAVE_REQUEST,
  GROUP_EDIT_SAVE_SUCCESS,
  GROUP_EDIT_SAVE_FAILURE,
  GROUP_EDIT_RESET
} from '../../actions/orderRoutingActions'

/**
 * Estado de la edición de un grupo desde su detalle (URBWEB-4359).
 *
 * Sólo lo que viene de la red: la respuesta de `GET orders/batch/update/` y
 * el estado del guardado. El borrador —qué orden se movió a dónde— vive en la
 * pantalla, porque es suyo y se descarta al salir.
 *
 * `guardados` cuenta los guardados que salieron bien: la pantalla lo observa
 * para avisar y volver a pedir el grupo, ya recalculado.
 */
export const initialState = {
  isFetching: false,
  data: null,
  error: null,
  isSaving: false,
  saveError: null,
  guardados: 0
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GROUP_EDIT_CONTEXT_REQUEST:
      return { ...state, isFetching: true, error: null }

    case GROUP_EDIT_CONTEXT_SUCCESS:
      return { ...state, isFetching: false, data: action.data }

    case GROUP_EDIT_CONTEXT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.errors || action.data || {}
      }

    case GROUP_EDIT_SAVE_REQUEST:
      return { ...state, isSaving: true, saveError: null }

    case GROUP_EDIT_SAVE_SUCCESS:
      return { ...state, isSaving: false, guardados: state.guardados + 1 }

    case GROUP_EDIT_SAVE_FAILURE:
      return {
        ...state,
        isSaving: false,
        saveError: action.errors || action.data || {}
      }

    case GROUP_EDIT_RESET:
      return initialState

    default:
      return state
  }
}
